<template>
  <v-card color="basil" flat>
    <v-card-text>
      <v-row justify="center" class="pa-4 my-4">
        <v-col md="12">
          <v-card>
            <v-card-title class="px-4 py-2 blue darken-4">
              <h3 class="subtitle-1 font-weight-bold white--text">
                Requested Sample
              </h3>
            </v-card-title>

            <v-simple-table class="ma-4" v-if="fields.properties">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th width="20%">Remarks</th>
                    <td class="nl2br">{{fields.properties}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table class="ma-4">
              <template v-slot:default>
                <tbody>
                  <tr class="no-hover">
                    <th colspan="2">
                      Rationale for Requested Sample Amount
                    </th>
                  </tr>
                  <tr>
                    <th class="indent">a.  Justification for the requested sample amount</th>
                    <td class="nl2br">{{ fields.sample_description_1_1 }}</td>
                  </tr>
                  <tr>
                    <th class="indent">b.  The minimum sample amount required per measurement</th>
                    <td class="nl2br">{{ fields.sample_description_1_2 }}</td>
                  </tr>
                  <tr class="no-hover">
                    <th colspan="2">
                      Sample Allocation Flexibility (Descoping & Sharing Options)
                    </th>
                  </tr>
                  <tr>
                    <th class="indent">a.  Alternative analytical approach in case of reduced sample allocation</th>
                    <td class="nl2br">{{ fields.sample_description_2_1 }}</td>
                  </tr>
                  <tr>
                    <th class="indent">b.  Possibility of sharing the sample with other researchers</th>
                    <td class="nl2br">{{ fields.sample_description_2_2 }}</td>
                  </tr>
                  <tr>
                    <th class="indent">c.  Additional comments on sample allocation flexibility</th>
                    <td class="nl2br">{{ fields.sample_description_2_3 }}</td>
                  </tr>
                  <tr>
                    <th>Additional details or special considerations regarding the sample request</th>
                    <td class="nl2br">{{ fields.sample_description_3_1 }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table class="ma-4">
              <template v-slot:default>
                <thead>
                  <th>Priority</th>
                  <th>Asteroid</th>
                  <th>Type</th>
                  <th colspan="2">Sample</th>
                  <th width="20%">Description</th>
                  <th>Ryugu Sample Chamber /<br> Bennu Sample Source</th>
                  <th>Number of bottles</th>
                  <th>Requested size<br>of samples [mm]</th>
                  <th>Requested weight<br>of samples [mg]</th>
                </thead>
                <tbody>
                  <tr v-for="item in fields.requested_samples" :key="item.id" :sample_lists="sample_lists">
                    <template v-if="item.sample_id">
                      <td class="text-center">{{ item.priority }}</td>
                      <td class="text-center">{{ item.db_type == 2 ? 'Bennu' : 'Ryugu' }}</td>
                      <td class="text-center">{{ sampleTypes[item.sample_type] }}</td>
                      <!-- DBに合わせたURLに変更 -->
                      <td width="12%" class="text-center" v-if="item.db_type == 2">
                        <a v-bind:href="bennuSampleDBUrl + item.sample_id" target=”_blank”>{{ sample_lists[item.sample_id + '_' + item.db_type].name }}</a>
                      </td>
                      <td width="12%" class="text-center" v-else>
                        <a v-bind:href="sampleDBUrl + item.sample_id" target=”_blank”>{{ sample_lists[item.sample_id + '_' + item.db_type].name }}</a>
                      </td>
                      <!-- sample情報をtypeによって変更 -->
                      <td class="text-left pl-1" v-if="item.sample_type == 0">
                        [{{ sample_lists[item.sample_id + '_' + item.db_type].size | sizeMM }} mm, {{ sample_lists[item.sample_id + '_' + item.db_type].weight }} mg]
                      </td>
                      <td class="text-left pl-1" v-else-if="item.sample_type == 1">
                        [{{ sample_lists[item.sample_id + '_' + item.db_type].weight }} mg]
                      </td>
                      <td class="text-left pl-1" v-else-if="item.sample_type == 2">
                          [{{ sample_lists[item.sample_id + '_' + item.db_type].pressure }} Pa, {{ sample_lists[item.sample_id + '_' + item.db_type].volume }} ml]
                      </td>
                      <td class="text-left pl-1" v-else-if="item.sample_type == 3">
                      </td>
                      <td class="text-left pl-1" v-else-if="item.sample_type == 4">
                        [{{ sample_lists[item.sample_id + '_' + item.db_type].size | sizeMM }} mm, {{ sample_lists[item.sample_id + '_' + item.db_type].weight }} mg]
                      </td>

                      <td class="text-center">{{ sample_lists[item.sample_id + '_' + item.db_type].description }}</td>
                      
                      <!-- chamberはAnyでない場合、Sampleの値を表示 -->
                      <!-- db=bennuであればSampleのsourceを表示 -->
                      <td class="text-center" v-if="item.db_type == 2">
                        {{ sample_lists[item.sample_id + '_' + item.db_type].source ? sample_lists[item.sample_id + '_' + item.db_type].source : '' }}
                      </td>
                      <!-- db=ryuguであればSampleのchamberを表示 -->
                      <td class="text-center" v-else>
                        {{ sample_lists[item.sample_id + '_' + item.db_type].chamber ? sample_lists[item.sample_id + '_' + item.db_type].chamber : '' }}
                      </td>
                      
                      <!-- type=2 のみnumber of bottles表示 -->
                      <td class="text-center" v-if="item.sample_type == 2">{{ item.number_of_bottles }}</td>
                      <td class="text-center" v-else>-</td>

                      <!-- type=0or4 のみsize表示 -->
                      <td class="text-center" v-if="item.sample_type == 0 || item.sample_type == 4">{{ sample_lists[item.sample_id + '_' + item.db_type].size | sizeMM }}</td>
                      <td class="text-center" v-else>-</td>

                      <!-- type=0or1or4 のみweight表示 -->
                      <td class="text-center" v-if="item.sample_type == 0 || item.sample_type == 1 || item.sample_type == 4">{{ sample_lists[item.sample_id + '_' + item.db_type].weight }}</td>
                      <td class="text-center" v-else>-</td>
                    </template>
                    <template v-else-if="item.sample_id == null">
                      <!-- Anyの場合 -->
                      <td class="text-center">{{ item.priority }}</td>
                      <td class="text-center">{{ item.db_type == 2 ? 'Bennu' : 'Ryugu' }}</td>
                      <td class="text-center">{{ sampleTypes[item.sample_type] }}</td>
                      <td class="text-center" colspan="2">Any</td>
                      <td class="text-center">-</td>

                      <!-- db_type=1 && type=0or1or4 の場合にdish表示 -->
                      <td class="text-center" v-if="item.db_type == 2 && (item.sample_type == 0 || item.sample_type == 1 || item.sample_type == 4)">
                        {{ dishes[item.dish] }}
                      </td>
                      <!-- db_type=2 && type=0or1or4 の場合にchamber表示 -->
                      <td class="text-center" v-else-if="item.db_type == 1 && (item.sample_type == 0 || item.sample_type == 1 || item.sample_type == 4)">
                        {{ chambers[item.chamber] }}
                      </td>
                      <td class="text-center" v-else>
                        -
                      </td>

                      <td class="text-center">-</td>
                      <td class="text-center">{{ (item.size ? item.size : "-") | sizeMM }}</td>
                      <td class="text-center">{{ item.weight ? item.weight : "-" }}</td>
                    </template>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                    <td colspan="8" class="text-right">Total</td>
                    <td class="text-center">{{ requestedSampleTotal }}</td>
                  </tr>
                </tfoot>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col md="12">
          <v-card>
            <v-card-title class="px-4 py-2 blue darken-4">
              <h3 class="subtitle-1 font-weight-bold white--text">
                Assigned Sample
              </h3>
            </v-card-title>

            <v-simple-table class="mt-6">
              <template v-slot:default>
                <thead>
                  <th>Asteroid</th>
                  <th>SampleID</th>
                  <th>Size [mm]</th>
                  <th>Weight [mg]</th>
                  <th>Assigned weight of sample [mg]</th>
                </thead>

                <tbody>
                  <tr v-for="item in fields.assigned_samples_status_true" :key="item.id" :sample_lists="sample_lists">
                    <template>
                      <td class="text-center">{{ item.db_type == 2 ? 'Bennu' : 'Ryugu' }}</td>
                      <td class="text-center" v-if="item.db_type == 2">
                        <a v-bind:href="bennuSampleDBUrl + item.sample_id" target=”_blank”>{{ sample_lists[item.sample_id + '_' + item.db_type].name }}</a>
                      </td>
                      <td class="text-center" v-else>
                        <a v-bind:href="sampleDBUrl + item.sample_id" target=”_blank”>{{ sample_lists[item.sample_id + '_' + item.db_type].name }}</a>
                      </td>
                      <td class="text-center">
                        {{ sample_lists[item.sample_id + '_' + item.db_type].size | sizeMM }}
                      </td>
                      <td class="text-center">
                        {{ sample_lists[item.sample_id + '_' + item.db_type].weight }}
                      </td>
                      <td class="text-center">{{ item.weight }}</td>
                    </template>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="text-right">Total</td>
                    <td class="text-center">{{ assignedSampleTotal }}</td>
                  </tr>
                </tfoot>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'tabAssignedSample',
  props: ['fields', 'sample_lists', 'sampleDBUrl', 'bennuSampleDBUrl', 'requestedSampleTotal', 'assignedSampleTotal', 'sampleTypes', 'chambers', 'dishes'],
  data() {
    return {
    };
  },
  filters: {
    sizeMM(value) {
      if (isNaN(value) || value == 0) {
        return "-";
      }
      const size = value / 1000;
      return size.toFixed(3);
    }
  },
};
</script>
<style>
.indent {
  padding-left: 2em;
}

.no-hover {
    background-color: inherit;
}
</style>